






































































































































import { Component, PropSync, Vue } from 'vue-property-decorator';
import FlagshipProfilingStepFinancialHabitsViewModel
  from '@/vue-app/view-models/components/flagship/flagship-profiling/flagship-profiling-step-financial-habits-view-model';

@Component({
  name: 'FlagshipProfilingStepFinancialHabits',
  components: {
    CustomTooltip: () => import('@/vue-app/components/custom/CustomTooltip.vue'),
  },
})
export default class FlagshipProfilingStepFinancialHabits extends Vue {
  @PropSync('isLoading', { type: Boolean, required: false, default: false })
  synced_is_loading!: boolean;

  @PropSync('backButtonText', {
    type: String,
    required: false,
    default: 'Regresar',
  })
  synced_back_button_text!: string;

  @PropSync('continueButtonText', {
    type: String,
    required: false,
    default: 'Continuar',
  })
  synced_continue_button_text!: string;

  @PropSync('isEditingPersonalityProfile', {
    type: Boolean,
    required: false,
    default: false,
  })
  synced_is_editing_personality_profile!: boolean;

  flagship_habits_view_model = Vue.observable(
    new FlagshipProfilingStepFinancialHabitsViewModel(this),
  );

  created() {
    this.flagship_habits_view_model.initialize(this.synced_is_editing_personality_profile);
  }
}
